import type {Root} from 'mdast';
import mdastToString from 'mdast-util-to-string';
import remarkGfm from 'remark-gfm';
import remarkParse from 'remark-parse';
import {unified} from 'unified';

const PREVIEW_KEYS = [
  'command',
  'path',
  'file_path',
  'filepath',
  'filename',
  'query',
  'pattern',
  'url',
  'name',
  'expression',
  'prompt',
];

const collapseWhitespace = (s: string): string => s.replace(/\s+/g, ' ').trim();

type JsonValue = string | number | boolean | null | JsonValue[] | JsonObject;
interface JsonObject {
  [key: string]: JsonValue;
}

const isJsonObject = (value: JsonValue): value is JsonObject =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

export const extractToolArgsPreview = (argsText?: string): string => {
  if (!argsText) {
    return '';
  }
  let parsed: JsonValue;
  try {
    parsed = JSON.parse(argsText);
  } catch {
    return collapseWhitespace(argsText);
  }

  if (!isJsonObject(parsed)) {
    return collapseWhitespace(argsText);
  }

  const orderedKeys = [
    ...PREVIEW_KEYS,
    ...Object.keys(parsed).filter(k => !PREVIEW_KEYS.includes(k)),
  ];
  for (const key of orderedKeys) {
    const value = parsed[key];
    if (typeof value !== 'string') {
      continue;
    }
    const preview = collapseWhitespace(value);
    if (preview.length > 0) {
      return preview;
    }
  }
  return collapseWhitespace(argsText);
};

const reasoningParser = unified().use(remarkParse).use(remarkGfm);

export const extractReasoningPreview = (text: string): string => {
  if (!text) {
    return '';
  }
  const tree = reasoningParser.parse(text) as Root;
  for (const node of tree.children) {
    const plain = collapseWhitespace(mdastToString(node));
    if (plain.length > 0) {
      return plain;
    }
  }
  return '';
};
